const INPUT_CLASS = "w-full bg-[#0a1628] border border-[#1c2a3d] rounded-md px-4 py-2 text-[#fdfbf7] focus:border-[#d4af37] focus:ring-1 focus:ring-[#d4af37] transition-all outline-none text-sm";

export default function CrudFormField({ field, value, onChange }) {
  const handleChange = (val) => onChange(field.key, val);

  if (field.type === 'textarea') {
    return (
      <div>
        <label className="block text-sm text-[#a3b1c6] mb-1.5">{field.label}</label>
        <textarea
          data-testid={`form-${field.key}`}
          value={value || ''}
          onChange={(e) => handleChange(e.target.value)}
          rows={3}
          className={`${INPUT_CLASS} resize-none`}
        />
      </div>
    );
  }

  if (field.type === 'boolean') {
    return (
      <div>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            data-testid={`form-${field.key}`}
            type="checkbox"
            checked={!!value}
            onChange={(e) => handleChange(e.target.checked)}
            className="accent-[#d4af37]"
          />
          <span className="text-sm text-[#a3b1c6]">{field.label}</span>
        </label>
      </div>
    );
  }

  if (field.type === 'select') {
    return (
      <div>
        <label className="block text-sm text-[#a3b1c6] mb-1.5">{field.label}</label>
        <select
          data-testid={`form-${field.key}`}
          value={value || ''}
          onChange={(e) => handleChange(e.target.value)}
          className={INPUT_CLASS}
        >
          {field.options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>
    );
  }

  return (
    <div>
      <label className="block text-sm text-[#a3b1c6] mb-1.5">{field.label}</label>
      <input
        data-testid={`form-${field.key}`}
        type={field.type || 'text'}
        value={value || ''}
        onChange={(e) => handleChange(e.target.value)}
        className={INPUT_CLASS}
      />
    </div>
  );
}
